import { motion } from "framer-motion";

export function Footer() {
  return (
    <footer className="w-screen bg-white dark:bg-black border-t border-black/10 dark:border-white/10 py-10 justify-center items-center">
      <div className="container w-screen">
        <div className="w-screen">
          <motion.div 
            className="flex flex-col md:flex-row justify-between items-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="mb-6 md:mb-0 ml-6">
              <div className="flex items-center">
                <span className="text-teal-600 dark:text-teal-400 font-bold text-xl">Elevita</span>
                <span className="text-black dark:text-white ml-1 font-bold text-xl">AI</span>
              </div>
              <p className="mt-2 text-black dark:text-[#E0E0E0] text-sm">Clarity in crisis. Confidence in care.</p>
            </div>
            
            <div className="flex items-center mr-6">
              <div className="bg-[#00C2CB] bg-opacity-10 border border-[#00C2CB] border-opacity-30 px-4 py-2 rounded-full">
                <p className="text-sm">
                  <span className="text-teal-600 dark:text-teal-400">Founder-led.</span> 
                  <span className="text-black dark:text-white"> Built in Australia.</span>
                </p>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="mt-10 pt-6 border-t border-gray-800 text-center text-sm text-black dark:text-white"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <p>&copy; {new Date().getFullYear()} Elevita AI. All rights reserved.</p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
}
